import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

const EditAboutMe = ({ Show, Hide, Title }) => {
  return (
    <>
      <Modal show={Show} onHide={Hide}>
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold hstack gap-2"
            style={{ fontSize: 15 }}
          >
            <span>{Title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-2 section-title d-block">
            <Form.Label className="mb-1 fw-bold hstack gap-2">
              <FiCalendar />  Start Date
            </Form.Label>
            <Form.Control
              style={{ fontSize: 12 }}
              type="date"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="outline-primary"
            onClick={Hide}
          >
            Cancel
          </Button>
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="primary"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditAboutMe;
